import axios from "axios";
import { baseUrl } from "../../../enum/constant";
import { useEffect, useState } from "react";

const VerificationStatus = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const [message, setMessage] = useState(""); // To display the message

  const fetchVerificationStatus = async (userId) => {
    setLoading(true);
    setError(null); // Reset error state before making the API call

    try {
      const base = baseUrl;
      // Use userId in the API request
      const response = await axios.get(`${base}api/status-applicant/${userId}`);
      setStatusData(response.data.data); // Save the data to state
      setMessage(response.data.message); // Save the message from the response
    } catch (err) {
      // Check for network or specific API errors
      if (err.response) {
        setError(
          `Error: ${err.response.data.message || "Failed to fetch data."}`
        );
      } else {
        setError("Network error. Please check your connection.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId"); // Get logged-in user ID from localStorage

    if (userId) {
      fetchVerificationStatus(userId); // Fetch verification status using the user ID
    } else {
      setMessage("User is not logged in.");
    }
  }, []); // Fetch status data on component mount

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner or loading animation
  }

  if (error) {
    return <div style={{ color: "red" }}>{error}</div>; // Display error message
  }

  return (
    <>
      <h5 className="verification-heading">Verification Status</h5>
      {statusData.length === 0 ? (
        <p>No verification status available.</p>
      ) : (
        statusData.map((item, index) => (
          <div className="info-box-setting">
            <p className="mb-2">
              <strong>Verification Result</strong>
            </p>
            <p className="last-p-tag">{item.reviewStatusresult}</p>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <strong>Name</strong> <span>{item.name}</span>
                </p>
                <p>
                  <strong>Email</strong> <span>{item.email}</span>
                </p>
                <p>
                  <strong>Final Result</strong> <span>{item.finalResults}</span>
                </p>
                <p>
                  <strong>Moderation Comment</strong>{" "}
                  <span>{item.moderationComment}</span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <strong>Country</strong> <span>{item.country}</span>
                </p>
                <p>
                  <strong>Phone</strong> <span>{item.phone}</span>
                </p>
                <p>
                  <strong>Client Comment</strong>:{" "}
                  <span>{item.clientComment}</span>
                </p>
              </div>
            </div>
            <div className="row status-box">
              <div className="col-md-6">
                <span
                  className={`${
                    item.emailStatus === "GREEN" ? "success" : "pending"
                  }`}
                >
                  Email Status:
                  <strong>
                    <img
                      src={
                        item.emailStatus === "GREEN"
                          ? "assets/images/check-success.png"
                          : "assets/images/pending-clock.png"
                      }
                      alt="Email Status"
                    />
                    {item.emailStatus}
                  </strong>
                </span>
              </div>

              <div className="col-md-6">
                <span
                  className={`${
                    item.phoneStatus === "GREEN" ? "success" : "pending"
                  }`}
                >
                  Phone Status:
                  <strong>
                    <img
                      src={
                        item.phoneStatus === "GREEN"
                          ? "assets/images/check-success.png"
                          : "assets/images/pending-clock.png"
                      }
                      alt="Phone Status"
                    />
                    {item.phoneStatus}
                  </strong>
                </span>
              </div>

              <div className="col-md-6">
                <span
                  className={`${
                    item.docStatus === "GREEN" ? "success" : "pending"
                  }`}
                >
                  Document Status:
                  <strong>
                    <img
                      src={
                        item.docStatus === "GREEN"
                          ? "assets/images/check-success.png"
                          : "assets/images/pending-clock.png"
                      }
                      alt="Document Status"
                    />
                    {item.docStatus}
                  </strong>
                </span>
              </div>

              <div className="col-md-6">
                <span
                  className={`${
                    item.selfieStatus === "GREEN" ? "success" : "pending"
                  }`}
                >
                  Selfie Status:
                  <strong>
                    <img
                      src={
                        item.selfieStatus === "GREEN"
                          ? "assets/images/check-success.png"
                          : "assets/images/pending-clock.png"
                      }
                      alt="Selfie Status"
                    />
                    {item.selfieStatus}
                  </strong>
                </span>
              </div>
            </div>
          </div>
        ))
      )}
    </>
  );
};

export default VerificationStatus;
